import { useQuery } from "@tanstack/react-query";
import { getCallMessages, CallsListParams } from "../../api/call/call.api";
import { qk } from "../../lib/queryKeys";

export function useGetCallMessages(
  callId?: string,
  params?: CallsListParams
) {
  return useQuery({
    queryKey: callId ? qk.callMessages(callId, params) : ["calls", "messages"],
    queryFn: () => {
      if (!callId) {
        return Promise.resolve([]);
      }
      return getCallMessages(callId, params);
    },
    enabled: Boolean(callId),
    staleTime: 30_000,
  });
}
